import React, { useEffect, useState } from "react";
import styles from "./DataTableWithFilters.module.css";
import { Input, Pagination, Radio, Table } from "antd";
import styled from "@emotion/styled";
import CustomTabs from "../CustomTabs";
import { MdKeyboardCommandKey } from "react-icons/md";
import DurationPicker from "../../CommonComponents/InputControls/DurationPicker";
import DateRangePicker from "../../CommonComponents/InputControls/DateRangePicker";
import SortingSelector from "../../CommonComponents/InputControls/SortingSelector";
import FilterSelector from "../../CommonComponents/InputControls/FilterSelector";

const CustomDataTable = styled(Table)`
  && .ant-table-thead .ant-table-cell {
    background-color: transparent;
  }

  && .ant-table-thead th {
    color: #909090;
    font-size: 13px !important;
    background-color: #f9f9f9 !important;
    padding: 10px 16px;
  }

  && .ant-table table {
    font-size: 14px;
  }

  && .ant-table-content table {
    background: #f9f9f9;
    padding: 0px 5px;
  }

  && .ant-table-tbody {
    background: white;
  }
`;

const CustomPagination = styled(Pagination)`
  && .ant-pagination-options {
    display: none;
  }

  && .ant-pagination-prev {
    margin-inline-end: 0px !important;
    min-width: 26px !important;
  }

  && .ant-pagination-prev > .ant-pagination-item-link {
    border: 1px solid black;
    background: white;
    width: 20px !important;
    height: 20px;
    min-width: 8px !important;
  }

  && .ant-pagination-next > .ant-pagination-item-link {
    border: 1px solid black;
    background: white;
    width: 20px !important;
    height: 20px;
    min-width: 21px;
  }

  && .ant-pagination-simple-pager {
    display: none !important;
  }
`;

const CustomRadioGroup = styled(Radio.Group)`
  && .ant-radio-button-wrapper {
    height: 38.6px;
    padding-block-start: 3px;
    color: #0d2159;
    border: 1px solid #41414080;
  }

  && .ant-radio-button-checked {
    border: none;
  }

  && .ant-radio-button-wrapper:has(span.ant-radio-button-checked) {
    background: #f4f5f7;
    font-weight: 500;
  }
`;

const DataTableWithFilters = ({
  columns,
  data,
  scroll,
  title,
  setCounts,
  selectedTab,
  onTabChange,
  tabOptions,
  tableKey,
  loading,
  total,
  hideSearch,
  radioTabOptions,
  pageSize,
  hideHeader,
  handlePageChange,
  sortOptions,
  showDatePicker,
  handleSortChange,
  hideFooter,
  selectedSort,
  handleSearch,
  handleFilterChange,
  buttonComponent,
}) => {
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);
  const ButtonComponent = buttonComponent;

  const handleTabChange = (value) => {
    onTabChange?.(value);
  };

  const onSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
  };

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      handleSearch?.(searchInput);
    }, 1000); // Debounce time: 50 milliseconds

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [searchInput]);

  const onPageChange = (value) => {
    setPage(value);
    handlePageChange(value > page ? true : false);
  };

  return (
    <div>
      {!hideHeader && (
        <div className={styles.content_header}>
          {title && <div className={styles.label}>{title}</div>}
          {showDatePicker && (
            <div className={styles.date_selection}>
              <DurationPicker />
              <DateRangePicker />
            </div>
          )}

          {sortOptions && (
            <div className={styles.date_selection}>
              {radioTabOptions && (
                <CustomRadioGroup
                  onChange={(e) => handleTabChange(e.target.value)}
                  value={selectedTab}
                >
                  {radioTabOptions.map((item) => {
                    return (
                      <Radio.Button value={item.value}>
                        {item.lable}
                      </Radio.Button>
                    );
                  })}
                </CustomRadioGroup>
              )}
              <SortingSelector
                selected={selectedSort}
                handleChange={handleSortChange}
                options={sortOptions}
              />
              <FilterSelector handleFilterChange={handleFilterChange} />
            </div>
          )}

          <div className={styles.menu_wrap}>
            {buttonComponent && <ButtonComponent />}
            {!hideSearch && (
              <Input
                placeholder="Search..."
                className={styles.search_bar}
                onChange={onSearch}
                suffix={
                  <div className={styles.search_suffix_wrap}>
                    <MdKeyboardCommandKey />T
                  </div>
                }
              />
            )}
            {tabOptions && (
              <CustomTabs
                defaultValue={selectedTab}
                onChange={handleTabChange}
                options={tabOptions}
                style={`&& .ant-segmented-group {
             margin-top: 1.5px !important;
           }`}
              />
            )}
          </div>
        </div>
      )}
      <div className={styles.table_wrap}>
        <CustomDataTable
          columns={columns}
          dataSource={data}
          className={styles.table_wrap}
          pagination={false}
          scroll={scroll}
          key={tableKey}
          loading={loading}
        />
        {!hideFooter && (
          <div className={styles.footer_wrap}>
            <div className={styles.footer_text}>
              <span className={styles.black_text}>
                Showing {data?.length || 0}
              </span>{" "}
              of {total}
            </div>
            <div className={styles.pagination_wrap}>
              <CustomPagination
                onChange={onPageChange}
                simple={{ readOnly: true }}
                defaultCurrent={1}
                loading={loading}
                total={total}
                hideOnSinglePage={true}
              />
              Page {page} of {Math.ceil(total / 10)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DataTableWithFilters;
